import { render, staticRenderFns } from "./wxpayment.vue?vue&type=template&id=7af78210&scoped=true"
import script from "./wxpayment.vue?vue&type=script&lang=ts"
export * from "./wxpayment.vue?vue&type=script&lang=ts"
import style0 from "./wxpayment.vue?vue&type=style&index=0&id=7af78210&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af78210",
  null
  
)

export default component.exports